module.exports = __webpack_public_path__ + "img/noDatas.c5fea07f.png";